import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { user } from '@/store/modules/user'
import { restaurant } from '@/store/modules/restaurant'
import { hotel } from '@/store/modules/hotel'
import { partner } from '@/store/modules/partner'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user,
    restaurant,
    hotel,
    partner
  },
  strict: true,
  plugins: [
    createPersistedState({
      key: 'LOCA_PORTAL_STATE'
    })
  ]
})
